import classNames from 'classnames'
import { ReactNode } from 'react'
import sanitize from 'sanitize-html'
import sanitizeHTML from 'sanitize-html'

import { Button } from 'core-components/library/button'

import styles from './NotificationTemplate.module.scss'

export interface INotificationTemplate {
  /**
   * Content for notification popup.
   */
  content: ReactNode
  /**
   * Handler for closing a notification popup.
   */
  closePopup: () => void
  /**
   * Color theme for notification popup.
   */
  type?: 'default' | 'success' | 'danger' | 'warning'
  /**
   * Visibility of close button.
   */
  closeButtonVisible?: boolean
}

const getType = (type: INotificationTemplate['type']) => {
  const availableTypes = ['default', 'success', 'danger', 'warning']
  if (!type) {
    return 'default'
  }
  if (availableTypes.includes(type)) {
    return type
  }
  console.error(
    sanitizeHTML(`NotificationTemplate: You set wrong type props. Current value is ${type}`)
  )
  return 'default'
}

export const NotificationTemplate = ({
  content,
  closePopup,
  type = 'default',
  closeButtonVisible = true,
}: INotificationTemplate) => {
  return (
    <div
      className={classNames(styles.root, styles[`root--${getType(type)}`])}
      data-testid={'notificationRoot'}
    >
      <div className={styles.body}>
        {typeof content === 'object' && <div>{content}</div>}
        {typeof content === 'string' && (
          <div dangerouslySetInnerHTML={{ __html: sanitize(content) }} />
        )}
      </div>
      {closeButtonVisible ? (
        <Button
          __testId={'notificationCloseButton'}
          className={styles.closeBtn}
          variant={'text'}
          color={'white'}
          iconButton={'kbase kbase-close'}
          onClick={() => closePopup()}
        />
      ) : (
        <></>
      )}
    </div>
  )
}
